import { useQuery } from '@tanstack/react-query'
import { useDataProvider } from 'react-admin'

const useMemberGroupDetails = (resource, ids, { enabled = true } = {}) => {
  const dataProvider = useDataProvider()
  const { data = [], isFetching } = useQuery({
    queryKey: [resource, 'membershipDetails', { ids: ids.map(String) }],
    queryFn: async ({ signal }) => {
      const members = []
      for (let index = 0; index < ids.length; index += 10) {
        const results = await Promise.allSettled(
          ids
            .slice(index, index + 10)
            .map((id) =>
              dataProvider.getOne(resource, { id, signal: dataProvider.supportAbortSignal ? signal : undefined }),
            ),
        )
        members.push(...results.filter((result) => result.status === 'fulfilled').map(({ value }) => value.data))
      }
      return members
    },
    enabled: enabled && ids.length > 0,
    refetchOnMount: 'always',
    retry: false,
  })

  return { data, isFetching }
}

export default useMemberGroupDetails
